import { BOOOKSHOPPER_URL } from '../utils/constants'

const getOrderItems = async (orderId) => {

  const response = await fetch(
    `${BOOOKSHOPPER_URL}/orders/${orderId}/items`, {
    method: 'get',
    headers: {
      'Content-Type': 'application/json',
    }
  }
  )
  if (response.status === 400) {
    const { errors } = await response.json()
    return { errors }
  }
  return await response.json()
}

export default getOrderItems;
